// Max file size for presigned-S3 file uploads (2 GB). Shared by Universe, Bulk, and Fast-ID upload forms.
export const MAX_UPLOAD_FILE_BYTES = 2 * 1024 * 1024 * 1024;

/** 1–40 for validate_universe / Fast-ID email_md5_column widget. */
export const UNIVERSE_COLUMN_OPTIONS = Array.from({ length: 40 }, (_, i) => String(i + 1));
